import i18n from 'i18next'
import * as R from 'ramda'
import Enums from '../Enum'

const {
    graph, dateType, alignment, contextOidLevel,
} = Enums

const createFormFields = (store, questionType, questionFields, formType, subQuestionType) => {
    const { question, getValueHolder, setValueHolder } = store

    const components = [
        {
            type: '2-cols',
            compName: 'questionShortNameAndType',
            name: '2-columns-options',
            show: true,
            fields: [
                {
                    type: 'input',
                    compName: 'questionShortName',
                    name: 'content.shortTitle',
                    label: i18n.t('q_shortname'),
                    placeholder: i18n.t('q_shortname_placeholder'),
                    defaultValue: store.getContentText('shortTitle'),
                    onBlur: ({ value }) => {
                        store.setContentText(value, 'shortTitle')
                        store.alterOverrideEdit(false)
                        store.changeEditField('')
                    },
                    isMandatory: true,
                    disabled: (store.isEdit && question.liveResponses && !(question.overrideEdit && store.editField === 'content.shortTitle')) || store.sgDisable,
                    onEdit: () => {
                        store.changeEditField('content.shortTitle')
                        store.toggleEditModal()
                    },
                    show: true,
                    cssClass: 'question-short-title',
                    warningMsg: store.fallbackTranslations.shortTitle,
                },
                {
                    type: 'questionPicker',
                    compName: 'questionTypeSelect',
                    name: 'questionType',
                    options: store.questionTypes,
                    value: question.questionTypeCode,
                    onChange: store.changeType,
                    disabled: store.disabledQuestionType,
                    show: true,
                },
            ],
        },
        {
            type: 'translate',
            compName: 'translate',
            show: true,
            hasLiveResponse: question.liveResponses,
        },
        {
            type: 'input',
            compName: 'questionShortName',
            name: 'content.shortTitle',
            label: i18n.t('q_shortname'),
            placeholder: i18n.t('q_shortname_placeholder'),
            defaultValue: store.getContentText('shortTitle'),
            onBlur: ({ value }) => {
                store.setContentText(value, 'shortTitle')
                store.alterOverrideEdit(false)
                store.changeEditField('')
            },
            isMandatory: true,
            disabled: (store.isEdit && question.liveResponses && !(question.overrideEdit && store.editField === 'content.shortTitle')) || store.sgDisable,
            onEdit: () => {
                store.changeEditField('content.shortTitle')
                store.toggleEditModal()
            },
            show: true,
        },
        {
            type: 'questionPicker',
            compName: 'questionTypeSelect',
            name: 'questionType',
            options: store.questionTypes,
            value: question.questionTypeCode,
            onChange: store.changeType,
            disabled: store.disabledQuestionType,
            stage: store.stage,
            show: true,
        },
        {
            type: 'product-type',
            compName: 'productType',
            name: 'productType',
            options: store.productMap,
            value: store.questionRespondents,
            onChange: store.changeProduct,
            isAccClose: store.isAccClose,
            toggleCheckAcc: store.toggleCheckAcc,
            show: true,
        },
        {
            type: 'info-acc',
            compName: 'proAcc',
            name: 'pro',
            title: i18n.t('tab_product_types'),
            desc: i18n.t('questionBuilder.productTypes.info.desc'),
            toggleShow: store.accState.pro,
            onToggle: store.toggleAccordion,
            show: !R.hasPath(['questionDetails', 'questionId'], store.appStore),
        },
        {
            type: 'info-acc',
            compName: 'infoAcc',
            name: 'info',
            title: i18n.t('q_info_title'),
            desc: i18n.t('q_info_desc'),
            show: true,
        },
        {
            type: 'historicalData',
            compName: 'historicalData',
            name: 'historicalData',
            title: i18n.t('q_info_title'),
            desc: i18n.t('q_info_desc'),
            oid: question.metadata.oid,
            hasLiveResponse: question.liveResponses,
            isNew: () => R.isNil(question.id),
            show: true,
        },
        {
            type: 'select',
            compName: 'language',
            name: 'locale',
            label: i18n.t('q_language'),
            value: store.selectedLocale,
            options: store.availableLocales,
            onBlur: store.changeLanguage,
            isMandatory: false,
            isSearchable: true,
            show: store.availableLocales.length > 0,
        },
        {
            type: 'text-editor',
            compName: 'questionText',
            toolbar: 'questionEditor',
            name: 'content.longTitle',
            label: i18n.t('q_question'),
            placeholder: i18n.t('q_questiontext_placeholder'),
            content: store.getContentText('longTitle'),
            config: {
                mergeFields: store.mergeFields,
            },
            onChange: (value) => store.setContentText(value, 'longTitle'),
            onBlur: () => {
                store.alterOverrideEdit(false)
                store.changeEditField('')
            },
            disabled: (store.isEdit && question.liveResponses && !(question.overrideEdit && store.editField === 'content.longTitle')) || store.sgDisable,
            onEdit: () => {
                store.changeEditField('content.longTitle')
                store.toggleEditModal()
            },
            warningMsg: store.fallbackTranslations.longTitle,
            show: true,
        },
        // ST - questionText for text block question
        {
            type: 'text-editor',
            compName: 'stQuestionText',
            toolbar: 'survey',
            name: 'content.content',
            label: i18n.t('q_question'),
            content: store.getContentText('content'),
            config: {
                toolbar: [
                    {
                        name: 'basic', items: ['Bold', 'Italic', 'Underline'],
                    },
                    {
                        name: 'list', items: ['NumberedList', 'BulletedList'],
                    },
                    {
                        name: 'link', items: ['Link', 'Unlink'],
                    },
                    {
                        name: 'code', items: ['Source'],
                    },
                    {
                        items: ['questionmergefields'],
                    },
                ],
                mergeFields: store.mergeFields,
            },
            onChange: (value) => store.setContentText(value, 'content'),
            onBlur: () => {
                store.alterOverrideEdit(false)
                store.changeEditField('')
            },
            disabled: (store.isEdit && question.liveResponses && !(question.overrideEdit && store.editField === 'content.content')) || store.sgDisable,
            onEdit: () => {
                store.changeEditField('content.content')
                store.toggleEditModal()
            },
            warningMsg: store.fallbackTranslations.content,
            show: true,
        },
        {
            type: 'input',
            compName: 'instructionText',
            name: 'content.instructions',
            label: i18n.t('q_instructiontext'),
            placeholder: i18n.t('q_instructiontext_placeholder'),
            defaultValue: store.getContentText('instructions'),
            onBlur: ({ value }) => store.setContentText(value, 'instructions'),
            isMandatory: false,
            disabled: store.sgDisable,
            warningMsg: store.fallbackTranslations.instructions,
            show: true,
        },
        {
            type: 'select',
            compName: 'questionCategory',
            name: 'category',
            label: i18n.t('category'),
            value: store.selectedCategory,
            options: R.pathOr([], ['appStore', 'questionDetails', 'questionCategories'], store),
            onBlur: store.changeQuestionCategory,
            isMandatory: false,
            isSearchable: true,
            show: (store.appStore.isExploriSuper()
                && store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT),
        },
        {
            type: 'select',
            compName: 'inheritOptions',
            name: 'inheritOptions',
            label: i18n.t('q_inheritoptions'),
            value: R.pathOr('', ['parentId', 'label'], store) === '' ? undefined : store.parentId,
            options: store.prevQuestions,
            onBlur: store.setInheritQuestion,
            tooltipTitle: i18n.t('q_inheritoptions'),
            tooltipText: i18n.t('q_inheritoptions_tooltip'),
            tooltipLink: 'https://kb.explori.com/knowledge/inherited-options',
            isMandatory: false,
            isSearchable: true,
            show: (store.contextOid === contextOidLevel.SURVEY_BUILDER
                && store.pageIndex > 0),
        },
        {
            type: 'select',
            compName: 'answerLibrary',
            name: 'prepopulate',
            label: i18n.t('q_prepopulate'),
            placeholder: i18n.t('q_prepopulate_placeholder'),
            value: store.prepopulateSelection,
            options: [
                {
                    value: 'CO',
                    label: i18n.t('questionType.CO'),
                },
            ],
            onBlur: store.prepopulateOnBlur,
            isMandatory: false,
            isSearchable: true,
            isClearable: true,
            show: !store.isEdit,
        },
        {
            type: 'checkbox-reactive',
            compName: 'optionalFeatures',
            name: 'columns-options',
            label: i18n.t('q_edit_columns'),
            cssClass: 'one-child',
            show: true,
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_ans_numeric'),
                    name: 'optionSet.hasNumericCodes',
                    checked: R.pathOr(false, ['hasNumericCodes'], getValueHolder('optionSet')),
                    onBlur: () => {
                        question.optionSet.toggleNumericCodes()
                        if (!R.pathOr(false, ['hasNumericCodes'], getValueHolder('optionSet'))) {
                            setValueHolder({ value: false, name: 'settings.report.allowQuadrantAnalysis' })
                        }
                    },
                    show: true,
                },
            ],
        },
        {
            type: 'checkbox-reactive',
            compName: 'colOptionalFeatures',
            label: i18n.t('q_edit_rows'),
            show: true,
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_ans_numeric'),
                    name: 'optionSetX.hasNumericCodes',
                    checked: R.pathOr(false, ['hasNumericCodes'], getValueHolder('optionSetX')),
                    onBlur: () => {
                        question.optionSetX.toggleNumericCodes()
                        if (!R.pathOr(false, ['hasNumericCodes'], getValueHolder('optionSetX'))) {
                            setValueHolder({ value: false, name: 'settings.report.allowQuadrantAnalysis' })
                        }
                    },
                    show: true,
                },
                {
                    type: 'checkbox',
                    label: i18n.t('q_ans_exclusive'),
                    name: 'optionSetX.isExclusive',
                    checked: R.pathOr(false, ['isExclusive'], getValueHolder('optionSetX')),
                    show: true,
                },
            ],
        },
        {
            type: 'checkbox-reactive',
            compName: 'rowOptionalFeatures',
            label: i18n.t('q_edit_columns'),
            cssClass: 'one-child',
            show: true,
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_ans_exclusive'),
                    name: 'optionSetY.isExclusive',
                    checked: R.pathOr(false, ['isExclusive'], getValueHolder('optionSetY')),
                    show: true,
                },
            ],
        },
        {
            type: 'checkbox-reactive',
            compName: 'questionLibraryOptions',
            name: 'question-library-options',
            label: i18n.t('q_optional_features'),
            cssClass: '',
            show: (store.contextOid <= contextOidLevel.QLIST_PRODUCT
                && store.appStore.isMasterSuper()),
            fields: [],
        },
        {
            type: 'checkbox',
            compName: 'isActive',
            label: i18n.t('active'),
            name: 'metadata.isActive',
            checked: getValueHolder('metadata.isActive'),
            show: (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT
                && store.appStore.isExploriClient()),
        },
        {
            type: 'checkbox',
            compName: 'isglobal',
            label: i18n.t('isglobal'),
            name: 'metadata.isGlobal',
            checked: getValueHolder('metadata.isGlobal'),
            show: (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT
                && store.appStore.isExploriClient()),
        },
        {
            type: 'checkbox',
            compName: 'isNewGlobal',
            label: i18n.t('isNewGlobal'),
            name: 'metadata.isNewGlobal',
            checked: getValueHolder('metadata.isNewGlobal'),
            show: (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT
                && store.appStore.isExploriClient()),
        },
        {
            type: 'checkbox',
            compName: 'isBenchmarked',
            label: i18n.t('q_allow_benchmarking'),
            name: 'metadata.isBenchmarked',
            checked: getValueHolder('metadata.isBenchmarked'),
            show: (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT
                && store.appStore.isExploriClient()),
        },
        {
            type: 'checkbox',
            compName: 'isFilterBenchmarked',
            label: i18n.t('q_allow_filterbenchmarking'),
            name: 'metadata.isFilterBenchmarked',
            checked: getValueHolder('metadata.isFilterBenchmarked'),
            show: (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT
                && store.appStore.isExploriClient()),
        },
        {
            type: 'checkbox',
            compName: 'isEditable',
            label: i18n.t('q_editable'),
            name: 'metadata.isEditable',
            checked: getValueHolder('metadata.isEditable'),
            show: (store.contextOid <= contextOidLevel.QLIST_PRODUCT
                && store.appStore.isMasterSuper()),
        },
        {
            type: 'checkbox',
            compName: 'dspYourScore',
            label: i18n.t('q_dspYourScore'),
            name: 'settings.report.dspYourScore',
            checked: getValueHolder('settings.report.dspYourScore'),
            show: (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT
                && store.appStore.isExploriClient()),
        },
        {
            type: 'checkbox',
            compName: 'isCurrency',
            label: i18n.t('q_is_currency'),
            name: 'settings.isCurrency',
            checked: getValueHolder('settings.isCurrency'),
            show: (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT
                && store.appStore.isExploriClient()),
        },
        {
            type: 'select',
            compName: 'dateType',
            name: 'settings.frontend.renderType',
            label: i18n.t('q_datetype'),
            value: getValueHolder('settings.frontend.renderType'),
            options: Object.values(dateType).map((value) => ({ value, label: i18n.t(`q_datetype_${value}`) })),
            isMandatory: false,
            isSearchable: true,
            show: true,
        },
        {
            type: 'date',
            compName: 'minDate',
            name: 'minDate',
            label: i18n.t('q_mindate'),
            value: getValueHolder('minDate', 'date'),
            maxDate: getValueHolder('maxDate', 'date'),
            isMandatory: false,
            show: true,
            allowManualDateEdit: true,
        },
        {
            type: 'date',
            compName: 'maxDate',
            name: 'maxDate',
            label: i18n.t('q_maxdate'),
            value: getValueHolder('maxDate', 'date'),
            minDate: getValueHolder('minDate', 'date'),
            isMandatory: false,
            show: true,
            allowManualDateEdit: true,
        },
        {
            type: 'input',
            compName: 'startDateText',
            name: 'startDateText',
            label: i18n.t('q_start_date_text'),
            defaultValue: store.getPlaceholderValue('left'),
            onBlur: (e) => store.setPlaceHolder(e, null),
            isMandatory: false,
            show: true,
        },
        {
            type: 'input',
            compName: 'endDateText',
            name: 'endDateText',
            label: i18n.t('q_end_date_text'),
            defaultValue: store.getPlaceholderValue('right'),
            onBlur: (e) => store.setPlaceHolder(null, e),
            isMandatory: false,
            show: R.pathOr(undefined, ['question', 'settings', 'frontend', 'renderType'], store) === 'DR',
        },
        {
            type: 'input',
            compName: 'noColumns',
            inputType: 'number',
            name: 'settings.frontend.displayCols',
            label: i18n.t('q_num_cols'),
            defaultValue: getValueHolder('settings.frontend.displayCols'),
            isMandatory: false,
            min: 1,
            show: true,
        },
        {
            type: 'select',
            compName: 'display',
            name: 'settings.frontend.alignment',
            label: i18n.t('q_alignment'),
            value: getValueHolder('settings.frontend.alignment'),
            options: Object.keys(alignment).map(
                (value) => ({ value, label: i18n.t(alignment[value]) }),
            ),
            isMandatory: false,
            isSearchable: true,
            show: true,
        },
        {
            type: 'checkbox',
            compName: 'npsStyle',
            label: i18n.t('q_enable_nps_format'),
            name: 'settings.frontend.renderNPS',
            checked: getValueHolder('settings.frontend.renderNPS'),
            show: true,
        },
        {
            type: 'checkbox',
            compName: 'enableQuadrant',
            label: i18n.t('q_enable_quadrant'),
            name: 'settings.report.allowQuadrantAnalysis',
            checked: getValueHolder('settings.report.allowQuadrantAnalysis'),
            show: (
                [contextOidLevel.QUESTION_EDITOR_CLIENT, contextOidLevel.QLIST_CLIENT]
                    .includes(store.contextOid)
                && (
                    ['SG', 'I', 'PC'].includes(question.questionTypeCode)
                    || R.pathOr(false, ['hasNumericCodes'], getValueHolder('optionSet'))
                    || R.pathOr(false, ['hasNumericCodes'], getValueHolder('optionSetX'))
                )
            ),
        },
        {
            type: 'checkbox',
            compName: 'enableIsRegistration',
            label: 'Is Registration',
            name: 'settings.report.isRegistration',
            checked: getValueHolder('settings.report.isRegistration'),
            show: (
                (
                    ['RD', 'I'].includes(question.questionTypeCode)
                )
            ),
        },
        {
            type: 'checkbox',
            compName: 'enableQuadrantNF',
            label: i18n.t('q_enable_quadrant'),
            name: 'settings.report.allowQuadrantAnalysis',
            checked: getValueHolder('settings.report.allowQuadrantAnalysis'),
            show: (
                [contextOidLevel.QUESTION_EDITOR_CLIENT, contextOidLevel.QLIST_CLIENT]
                    .includes(store.contextOid)
            ),
        },
        {
            type: 'select',
            compName: 'graphType',
            name: 'settings.report.graphType',
            label: i18n.t('q_graph_type'),
            value: getValueHolder('settings.report.graphType'),
            options: Object.values(graph).map((value) => ({ value, label: i18n.t(`graph.${value}`) })),
            isMandatory: false,
            isSearchable: true,
            show: true,
        },
        {
            type: 'checkbox',
            compName: 'enableMetrics',
            label: 'Enable Metrics',
            name: 'enableMetrics',
            checked: R.pathOr(false, ['optionSet', 'hasMetrics'], question),
            onBlur: store.toggleMetrics,
            show: store.appStore.isExploriAdmin(),
        },
        {
            type: 'text-editor',
            compName: 'textAbove',
            name: 'content.aboveText',
            label: i18n.t('q_text_above'),
            toolbar: 'survey',
            content: store.getContentText('aboveText', false),
            config: { mergeFields: store.mergeFields },
            onChange: (value) => store.setContentText(value, 'aboveText'),
            warningMsg: store.fallbackTranslations.aboveText,
            show: true,
        },
        {
            type: 'text-editor',
            compName: 'textBelow',
            name: 'content.belowText',
            label: i18n.t('q_text_below'),
            toolbar: 'survey',
            content: store.getContentText('belowText', false),
            config: { mergeFields: store.mergeFields },
            onChange: (value) => store.setContentText(value, 'belowText'),
            warningMsg: store.fallbackTranslations.belowText,
            show: true,
        },
        {
            type: 'input',
            compName: 'customCss',
            name: 'settings.frontend.classNames',
            label: i18n.t('q_custom_class'),
            defaultValue: getValueHolder('settings.frontend.classNames'),
            tooltipTitle: i18n.t('q_custom_class'),
            tooltipText: i18n.t('q_custom_class_tooltip'),
            isMandatory: false,
            show: true,
        },
        // NF custom class
        {
            type: 'input',
            compName: 'nfCustomCss',
            name: 'settings.classNames',
            label: i18n.t('q_custom_class'),
            defaultValue: getValueHolder('settings.classNames'),
            tooltipTitle: i18n.t('q_custom_class'),
            tooltipText: i18n.t('q_custom_class_tooltip'),
            isMandatory: false,
            show: true,
        },
        {
            type: 'input',
            compName: 'minNumOptions',
            inputType: 'number',
            name: 'settings.frontend.minChosen',
            label: i18n.t('q_min_options'),
            defaultValue: getValueHolder('settings.frontend.minChosen'),
            tooltipTitle: i18n.t('q_min_options'),
            tooltipText: i18n.t('q_minnumoptions_tooltip'),
            isMandatory: false,
            min: 0,
            max: getValueHolder('settings.frontend.maxChosen'),
            show: true,
        },
        {
            type: 'input',
            compName: 'maxNumOptions',
            inputType: 'number',
            name: 'settings.frontend.maxChosen',
            label: i18n.t('q_max_options'),
            defaultValue: getValueHolder('settings.frontend.maxChosen'),
            tooltipTitle: i18n.t('q_max_options'),
            tooltipText: i18n.t('q_maxnumoptions_tooltip'),
            isMandatory: false,
            min: getValueHolder('settings.frontend.minChosen') <= 2 ? 2 : getValueHolder('settings.frontend.minChosen'),
            show: true,
        },
        {
            type: 'checkbox-reactive',
            compName: 'displayOptions',
            name: 'display-options',
            label: i18n.t('q_display_options'),
            cssClass: '',
            show: true,
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_is_flipped'),
                    name: 'settings.frontend.isFlipped',
                    checked: getValueHolder('settings.frontend.isFlipped'),
                    show: true,
                },
                {
                    type: 'checkbox',
                    label: i18n.t('q_render_lines'),
                    name: 'settings.frontend.renderLines',
                    checked: getValueHolder('settings.frontend.renderLines'),
                    show: store.appStore.isExploriSuper(),
                },
            ],
        },
        {
            type: 'input',
            compName: 'minNum',
            inputType: 'number',
            name: 'settings.frontend.min',
            label: i18n.t('q_min_num'),
            defaultValue: getValueHolder('settings.frontend.min'),
            isMandatory: false,
            min: 0,
            max: getValueHolder('settings.frontend.max'),
            show: (
                question.questionTypeCode !== 'PC'
                || getValueHolder('settings.frontend.ignoreTotalValidation')
            ),
        },
        {
            type: 'input',
            compName: 'maxNum',
            inputType: 'number',
            name: 'settings.frontend.max',
            label: i18n.t('q_max_num'),
            defaultValue: getValueHolder('settings.frontend.max'),
            isMandatory: false,
            min: getValueHolder('settings.frontend.min'),
            show: true,
        },
        {
            type: 'input',
            compName: 'maxRankedItems',
            inputType: 'number',
            name: 'settings.frontend.maxRankedItems',
            label: i18n.t('q_max_ranked'),
            defaultValue: getValueHolder('settings.frontend.maxRankedItems'),
            tooltipTitle: i18n.t('q_max_ranked'),
            tooltipText: i18n.t('q_max_ranked_tooltip'),
            isMandatory: false,
            min: 0,
            show: true,
        },
        {
            type: 'checkbox-reactive',
            compName: 'switchInfoOptions',
            name: 'additional-options',
            label: i18n.t('q_additional_options'),
            show: (store.appStore.isExploriSuper()
                && (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT)),
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_switch'),
                    name: 'settings.frontend.switch.check',
                    onBlur: () => { store.resetSwitch() },
                    checked: Boolean(getValueHolder('settings.frontend.switch.check')),
                    show: store.appStore.isExploriSuper(),
                },
                {
                    type: 'checkbox',
                    label: i18n.t('q_display_info_icon'),
                    name: 'settings.frontend.info.check',
                    onBlur: () => { store.resetInfo() },
                    checked: Boolean(getValueHolder('settings.frontend.info.check')),
                    show: store.appStore.isExploriSuper(),
                },
            ],
        },
        {
            type: 'checkbox-reactive',
            compName: 'NFswitchInfoOptions',
            name: 'additional-options',
            label: i18n.t('q_additional_options'),
            show: (store.appStore.isExploriSuper()
                && (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT)),
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_display_info_icon'),
                    name: 'settings.frontend.info.check',
                    onBlur: () => { store.resetInfo() },
                    checked: Boolean(getValueHolder('settings.frontend.info.check')),
                    show: store.appStore.isExploriSuper(),

                },
            ],
            keepFixedSpacing: true,
        },
        {
            type: 'textarea',
            compName: 'infoText',
            name: 'settings.frontend.info',
            label: i18n.t('q_infotext'),
            defaultValue: store.getInfoValue(),
            onBlur: (e) => store.setInfo(e),
            isMandatory: false,
            show: Boolean(getValueHolder('settings.frontend.info.check')),
        },
        {
            type: 'select',
            compName: 'switchFormat',
            name: 'switchFormat',
            label: i18n.t('q_switch_format'),
            value: store.switchFormat,
            options: store.switchFormatOptions,
            onBlur: (obj) => {
                store.setSwitchFormat(obj)
                store.setValueHolder({ value: obj.value.left, name: 'settings.frontend.switch.0' })
                store.setValueHolder({ value: obj.value.right, name: 'settings.frontend.switch.1' })
            },
            isMandatory: false,
            isSearchable: true,
            show: Boolean(getValueHolder('settings.frontend.switch.check')) && (store.appStore.isExploriSuper()
                && (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT)),
        },
        {
            type: 'input',
            compName: 'switchLeftVal',
            name: 'settings.frontend.switch.0',
            label: i18n.t('q_switch_left_val'),
            defaultValue: getValueHolder('settings.frontend.switch.0'),
            onBlur: (obj) => { store.setSwitchValue(obj) },
            isMandatory: false,
            disabled: R.pathOr('', ['value', 'value'], store.switchFormat) !== '',
            show: Boolean(store.switchFormat) && (store.appStore.isExploriSuper()
                && (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT)),
        },
        {
            type: 'input',
            compName: 'switchRightVal',
            name: 'settings.frontend.switch.1',
            label: i18n.t('q_switch_right_val'),
            defaultValue: getValueHolder('settings.frontend.switch.1'),
            onBlur: (obj) => { store.setSwitchValue(obj) },
            isMandatory: false,
            disabled: R.pathOr('', ['value', 'value'], store.switchFormat) !== '',
            show: Boolean(store.switchFormat) && (store.appStore.isExploriSuper()
                && (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT)),
        },
        {
            type: 'checkbox',
            compName: 'switchNonRequiredOption',
            label: i18n.t('q_non_required_option'),
            name: question.questionType === 'FM'
                ? 'settings.nonRequired'
                : 'settings.frontend.nonRequired',
            checked: question.questionType === 'FM'
                ? getValueHolder('settings.nonRequired')
                : getValueHolder('settings.frontend.nonRequired'),
            show: Boolean(getValueHolder('settings.frontend.switch.check')) && (
                [473, 1].includes(store.appStore.tokenData.clientId)
                && store.appStore.isExploriAdmin()
                && (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT)
            ),
        },
        {
            type: 'checkbox-reactive',
            compName: 'addSwitchEstimateAllSubQue',
            name: 'NF-additional-options', // NF question only
            label: i18n.t('q_additional_options'),
            show: (store.appStore.isExploriSuper()
                && (store.contextOid === contextOidLevel.QUESTION_EDITOR_CLIENT)),
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_estimate_switch'),
                    name: 'question.settings.switch',
                    onBlur: store.toggleEstimateSwitch,
                    checked: Boolean(R.pathOr(false, ['settings', 'switch'], question)),
                    show: true,
                },
                {
                    type: 'checkbox',
                    label: i18n.t('q_non_required_option'),
                    name: 'question.settings.nonRequired',
                    onBlur: store.toggleNumberFormNonRequired,
                    checked: Boolean(R.pathOr(false, ['settings', 'nonRequired'], question)),
                    show: Boolean(R.pathOr(false, ['settings', 'switch'], question))
                        && [473, 1].includes(store.appStore.tokenData.clientId),
                },
                {
                    type: 'input',
                    label: i18n.t('q_non_required_text'),
                    name: 'question.settings.nonRequiredText',
                    defaultValue: store.getNonRequiredText(),
                    onBlur: (e) => store.changeNonRequiredText(e),
                    show: Boolean(R.pathOr(false, ['settings', 'nonRequired'], question))
                        && [473, 1].includes(store.appStore.tokenData.clientId),
                },
            ],
            keepFixedSpacing: true,
        },
        {
            type: 'input',
            compName: 'characterLimit',
            inputType: 'number',
            name: 'settings.frontend.charLimit',
            label: i18n.t('q_ans_char_limit'),
            defaultValue: getValueHolder('settings.frontend.charLimit'),
            isMandatory: false,
            min: 0,
            show: true,
        },
        {
            type: 'select',
            compName: 'validation',
            name: 'settings.frontend.validation',
            label: i18n.t('q_validation'),
            placeholder: i18n.t('select_list_none'),
            value: store.validationOptions.find(
                ({ value }) => (value === getValueHolder('settings.frontend.validation')),
            ),
            options: store.validationOptions,
            isMandatory: false,
            isSearchable: true,
            show: true,
            isClearable: true,
        },
        {
            type: 'input',
            compName: 'valueBefore',
            name: 'settings.frontend.prefix',
            label: i18n.t('q_value_before'),
            defaultValue: store.getFix('prefix'),
            onBlur: (e) => store.setFix(e, 'prefix'),
            isMandatory: false,
            show: true,
        },
        {
            type: 'input',
            compName: 'valueAfter',
            name: 'settings.frontend.postfix',
            label: i18n.t('q_value_after'),
            defaultValue: store.getFix('postfix'),
            onBlur: (e) => store.setFix(e, 'postfix'),
            isMandatory: false,
            show: true,
        },
        {
            type: 'input',
            compName: 'chartDisplayText',
            name: 'content.chartDisplayText',
            label: i18n.t('q_chart_display_text'),
            defaultValue: store.getContentText('instructions'),
            onBlur: ({ value }) => store.setContentText(value, 'instructions'),
            isMandatory: false,
            disabled: store.sgDisable,
            show: true,
        },
        {
            type: 'select',
            compName: 'format',
            name: 'settings.frontend.format',
            label: i18n.t('q_format'),
            value: getValueHolder('settings.frontend.format'),
            options: store.formatOptions,
            isMandatory: false,
            isSearchable: true,
            show: true,
        },
        {
            type: 'input',
            compName: 'maxSliderValue',
            inputType: 'number',
            name: 'settings.frontend.max',
            label: i18n.t('q_max_val'),
            defaultValue: getValueHolder('settings.frontend.max'),
            isMandatory: false,
            min: 0,
            show: true,
        },
        {
            type: 'checkbox-reactive',
            compName: 'rowWrap',
            label: i18n.t('questionBuilder.rows'),
            cssClass: 'gap-25',
            show: true,
            fields: [],
        },
        {
            type: 'checkbox-reactive',
            compName: 'colWrap',
            label: i18n.t('questionBuilder.cols'),
            cssClass: 'gap-25',
            show: true,
            fields: [],
        },
        {
            type: 'option-editor',
            compName: 'optionEditor',
            name: 'optionSet',
            optionSet: getValueHolder('optionSet'),
            selectedLocale: store.selectedLocale,
            defaultLocale: store.defaultLocale,
            initialLocale: question.metadata.initialLocale,
            questionTypeCode: question.questionTypeCode,
            changeSorting: (value, name) => store.changeSorting({ value, name: `optionSet.${name}` }),
            hasLiveResponse: question.liveResponses,
            inheritedOptions: store.inheritedOptions,
            isEdit: store.isEdit,
            contextOid: store.contextOid,
            toggleSkipLogic: store.toggleSkipLogic,
            availableLocales: store.availableLocales,
            addOption: (option) => store.addOption(option, 'optionSet', true),
            createSubQuestionStore: store.createSubQuestionStore,
            remSubQuestion: store.remSubQuestion,
            toggleSubQueModal: store.toggleSubQueModal,
            toggleSkipLogicAlertModal: store.toggleSkipLogicAlertModal,
            toggleSubQueMandatory: store.toggleSubQueMandatory,
            updateSubQuestionShortTitle: store.updateSubQuestionShortTitle,
            subQuestionMap: store.subQuestionMap,
            optionMenuComps: [],
            sortByComps: [],
            buttonComps: [],
            customFormSubQuestionType: store.customFormSubQuestionType,
            changeSubQuestionType: store.changeSubQuestionType,
            optionEditorLoader: store.optionEditorLoader,
            toggleOptionEditModal: store.toggleOptionEditModal,
            isExploriClient: store.appStore.isExploriClient,
            isExploriAdmin: store.appStore.isExploriAdmin,
            show: true,
        },
        {
            type: 'option-editor',
            compName: 'rowOptionEditor',
            name: 'optionSetY',
            optionSet: getValueHolder('optionSetY'),
            selectedLocale: store.selectedLocale,
            defaultLocale: store.defaultLocale,
            initialLocale: question.metadata.initialLocale,
            questionTypeCode: question.questionTypeCode,
            changeSorting: (value, name) => store.changeSorting({ value, name: `optionSetY.${name}` }),
            hasLiveResponse: question.liveResponses,
            inheritedOptions: store.inheritedOptions,
            isEdit: store.isEdit,
            contextOid: store.contextOid,
            toggleSkipLogic: store.toggleSkipLogic,
            availableLocales: store.availableLocales,
            addOption: (option) => store.addOption(option, 'optionSetY', true),
            createSubQuestionStore: store.createSubQuestionStore,
            remSubQuestion: store.remSubQuestion,
            toggleSubQueModal: store.toggleSubQueModal,
            toggleSkipLogicAlertModal: store.toggleSkipLogicAlertModal,
            toggleSubQueMandatory: store.toggleSubQueMandatory,
            updateSubQuestionShortTitle: store.updateSubQuestionShortTitle,
            subQuestionMap: store.subQuestionMap,
            optionMenuComps: [],
            sortByComps: [],
            buttonComps: [],
            customFormSubQuestionType: store.customFormSubQuestionType,
            changeSubQuestionType: store.changeSubQuestionType,
            optionEditorLoader: store.optionEditorLoader,
            toggleOptionEditModal: store.toggleOptionEditModal,
            isExploriClient: store.appStore.isExploriClient,
            isExploriAdmin: store.appStore.isExploriAdmin,
            show: true,
        },
        {
            type: 'option-editor',
            compName: 'colOptionEditor',
            name: 'optionSetX',
            optionSet: getValueHolder('optionSetX'),
            selectedLocale: store.selectedLocale,
            defaultLocale: store.defaultLocale,
            initialLocale: question.metadata.initialLocale,
            questionTypeCode: question.questionTypeCode,
            changeSorting: (value, name) => store.changeSorting({ value, name: `optionSetX.${name}` }),
            hasLiveResponse: question.liveResponses,
            isEdit: store.isEdit,
            contextOid: store.contextOid,
            toggleSkipLogic: store.toggleSkipLogic,
            availableLocales: store.availableLocales,
            addOption: (option) => store.addOption(option, 'optionSetX', true),
            createSubQuestionStore: store.createSubQuestionStore,
            remSubQuestion: store.remSubQuestion,
            toggleSubQueModal: store.toggleSubQueModal,
            toggleSkipLogicAlertModal: store.toggleSkipLogicAlertModal,
            toggleSubQueMandatory: store.toggleSubQueMandatory,
            updateSubQuestionShortTitle: store.updateSubQuestionShortTitle,
            subQuestionMap: store.subQuestionMap,
            optionMenuComps: [],
            sortByComps: [],
            buttonComps: [],
            customFormSubQuestionType: store.customFormSubQuestionType,
            changeSubQuestionType: store.changeSubQuestionType,
            optionEditorLoader: store.optionEditorLoader,
            toggleOptionEditModal: store.toggleOptionEditModal,
            isExploriClient: store.appStore.isExploriClient,
            isExploriAdmin: store.appStore.isExploriAdmin,
            show: true,
        },
        {
            type: 'select',
            compName: 'template',
            name: 'settings.frontend.template',
            label: i18n.t('q_template'),
            value: R.pathOr(undefined, ['settings', 'frontend', 'template'], question),
            options: store.questionTemplateOptions,
            onBlur: store.changeTemplate,
            isMandatory: false,
            isSearchable: true,
            isClearable: true,
            show: store.appStore.isExploriAdmin(),
        },
        {
            type: 'checkbox-reactive',
            compName: 'sliderSettings',
            name: 'slider-settings',
            label: i18n.t('q_slider_settings'),
            cssClass: '',
            show: store.appStore.isExploriAdmin(),
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_ignore_total_val'),
                    name: 'settings.frontend.ignoreTotalValidation',
                    checked: getValueHolder('settings.frontend.ignoreTotalValidation'),
                    onBlur: store.changeIgnoreValidation,
                    show: true,
                },
            ],
        },
        {
            type: 'checkbox-reactive',
            compName: 'sliderSettingsAdvanced',
            name: 'slider-settings-advanced',
            label: i18n.t('q_slider_settings'),
            cssClass: '',
            show: store.appStore.isExploriAdmin(),
            fields: [
                {
                    type: 'checkbox',
                    label: i18n.t('q_hide_slider_num'),
                    name: 'settings.frontend.hideValueIndicator',
                    checked: getValueHolder('settings.frontend.hideValueIndicator'),
                    show: true,
                },
                {
                    type: 'checkbox',
                    label: i18n.t('q_hide_total_no'),
                    name: 'settings.frontend.hideTotalIndicator',
                    checked: getValueHolder('settings.frontend.hideTotalIndicator'),
                    show: true,
                },
                {
                    type: 'checkbox',
                    label: i18n.t('q_hideZeros'),
                    name: 'settings.report.hideZero',
                    checked: getValueHolder('settings.report.hideZero'),
                    show: true,
                },
            ],
        },
        {
            type: 'select',
            compName: 'inheritMaxValueQue',
            name: 'settings.frontend.inheritMax',
            label: i18n.t('q_inherit_max_value_que'),
            value: R.pathOr('', ['settings', 'frontend', 'inheritMax'])(question).split('|')[0],
            options: store.parentQuestions,
            placeholder: i18n.t('q_inherit_max_value_que_placeholder'),
            isMandatory: false,
            isSearchable: true,
            show: store.appStore.isExploriAdmin(),
        },
        {
            type: 'select',
            compName: 'inheritMaxValueOpt',
            name: 'settings.frontend.inheritMax_opt',
            label: i18n.t('q_inherit_max_value_opt'),
            value: R.pathOr('', ['settings', 'frontend', 'inheritMax'])(question).split('|')[1],
            options: store.parentOptions[
                R.pathOr('', ['settings', 'frontend', 'inheritMax'])(question).split('|')[0]
            ] || [],
            placeholder: i18n.t('q_inherit_max_value_opt_placeholder'),
            onBlur: store.changeMaxInheritOption,
            isMandatory: false,
            isSearchable: true,
            show: store.appStore.isExploriAdmin()
                && Boolean(R.pathOr('', ['settings', 'frontend', 'inheritMax'])(question).split('|')[0]),
        },
        {
            type: 'checkbox-reactive',
            compName: 'sliderLabels',
            name: 'slider-label',
            label: i18n.t('q_slider_label'),
            cssClass: 'input-group',
            show: store.appStore.isExploriAdmin(),
            fields: [
                {
                    type: 'input',
                    compName: 'valueBefore',
                    name: 'settings.frontend.sliderLabels.left',
                    label: i18n.t('q_slider_label_left'),
                    defaultValue: store.getSliderLabel(0),
                    onBlur: ({ value }) => store.setSliderLabel(0, value),
                    isMandatory: false,
                    show: true,
                },
                {
                    type: 'input',
                    compName: 'valueBefore',
                    name: 'settings.frontend.sliderLabels.middle',
                    label: i18n.t('q_slider_label_middle'),
                    defaultValue: store.getSliderLabel(1),
                    onBlur: ({ value }) => store.setSliderLabel(1, value),
                    isMandatory: false,
                    show: true,
                },
                {
                    type: 'input',
                    compName: 'valueBefore',
                    name: 'settings.frontend.sliderLabels.right',
                    label: i18n.t('q_slider_label_right'),
                    defaultValue: store.getSliderLabel(2),
                    onBlur: ({ value }) => store.setSliderLabel(2, value),
                    isMandatory: false,
                    show: true,
                },
            ],
        },
        {
            type: 'headerRow',
            compName: 'headerRows',
            name: 'headerGroups',
            label: '',
            cssClass: 'input-group',
            show: store.showHeaderRow(),
        },
    ]

    const setObjFields = (fieldObj) => {
        const mainComp = components.find(
            ({ compName }) => (compName === Object.keys(fieldObj)[0]),
        )

        if (!mainComp) return null

        const objVal = Object.values(fieldObj)[0]

        if (Array.isArray(objVal)) {
            objVal.forEach((field) => {
                if (typeof field === 'object') {
                    mainComp.fields.push(setObjFields(field))
                } else {
                    const newComp = components.filter((comp) => (
                        (comp.compName === field) && comp.show
                    ))
                    if (newComp.length === 0) return
                    mainComp.fields.push(...newComp)
                }
            })
            mainComp.cssClass += mainComp.fields.length === 1 ? ' one-child' : ''
        } else {
            mainComp.optionMenuComps = objVal.optionMenu || []
            mainComp.sortByComps = objVal.sortBy || []
            mainComp.buttonComps = objVal.buttons || []
        }

        return mainComp
    }

    if (!R.hasPath([questionType, formType], questionFields)) return []

    const fields = formType === 'editSubQue'
        ? questionFields[questionType][formType][subQuestionType]
        : questionFields[questionType][formType]

    const allowedFields = fields.map(
        (fieldName) => {
            if (typeof fieldName === 'object') {
                return setObjFields(fieldName)
            }
            const comp = components.find(({ compName }) => (compName === fieldName))
            if (comp.type === 'checkbox-reactive') {
                comp.fields = comp.fields.filter((c) => (c.show))
                const { keepFixedSpacing } = comp
                const useOneChildSpacing = Boolean(!keepFixedSpacing) && comp.fields.length === 1
                comp.cssClass += useOneChildSpacing ? ' one-child' : ''
            }
            return comp
        },
    )

    return allowedFields
}

export default createFormFields
